<template>
  <div>
    <b-alert
      v-model="hasError"
      variant="danger"
      fade
    >
      {{ errorMessage }}
    </b-alert>
    <dx-tab-panel v-if="masterDetailData && masterDetailData.profiles[0]">
      <dx-item
        :title="$t('evaluation.tabTitle')"
        template="evaluation-tab"
      />
      <dx-item
        v-if="checkAdmin(currentUser.mitarbeiterId)"
        :title="$t('fundings.tabTitle')"
        template="funding-tab"
      />
      <evaluation-tab
        slot="evaluation-tab"
        :bestellungId="bestellungId"
        :permaLink="masterDetailData.permalink"
        :profileId="masterDetailData.profiles[0].field_001"
        :crmAdressId="masterDetailData.field_001"
        :eventPoolId="eventPoolId"
        :sortDateYear="getYear(sortDate)"
      />

      <funding-tab
        slot="funding-tab"
        :fundingData="masterDetailData"
      />
    </dx-tab-panel>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import {
    DxTabPanel,
    DxItem
  } from 'devextreme-vue/tab-panel'
  import EvaluationTab from '@/components/event/EvaluationTab.vue'
  import FundingTab from '@/components/event/FundingTab.vue'
  import { isAdmin } from '@/helpers/auth.js'

  export default {
    components: {
      DxTabPanel,
      DxItem,
      EvaluationTab,
      FundingTab
    },
    props: {
      masterDetailAdressId: {
        type: Number
      },
      eventPoolId: {
        type: Number
      },
      bestellungId: {
        type: Number
      },
      sortDate: {
        type: String
      }
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        masterDetailData: null
      }
    },
    created () {
      if (this.masterDetailAdressId) {
        this.getMasterDetailData()
      }
    },
    methods: {
      async getMasterDetailData () {
        try {
          const data = await this.$store.dispatch('event/GET_ADDRESS_BY_ID', this.masterDetailAdressId)
          if (data.errors) throw data.errors
          this.masterDetailData = data.data.response
        } catch (err) {
          this.hasError = true
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      getYear (sortDate) {
        const sortDateFormatted = new Date(sortDate)
        return sortDateFormatted.getFullYear()
      },
      checkAdmin (id) {
        return isAdmin(id)
      }
    },
    computed: {
      ...mapState({
        currentUser: state => state.user.currentUser
      })
    }
  }
</script>
<style lang="scss">
.dx-datagrid-rowsview .dx-row > .dx-master-detail-cell{
  padding: 5px;
}
</style>
